import { User } from '@/types';

export class UserMutator {
  public static toTabular(user: User, config: any): any {
    const tableConfig: any = {
      first_name: {
        value: user.first_name,
        property: 'user.first_name',
      },
      last_name: {
        value: user.last_name,
        property: 'user.last_name',
      },
      email: {
        value: user.email,
        property: 'user.email',
      },
      id: user.id,
    };
    if (config && config.exclude) {
      (config.exclude as string[]).forEach((value) => delete tableConfig[value]);
    }
    return tableConfig;
  }
}
